"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleBarGraph = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const SimpleBarGraphStyled = styled_components_1.default.div `
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;

	.simple-bar-track {
		flex: 1;
		height: ${props => props.$height}px;
		border-radius: ${props => props.$radius}px;
		overflow: hidden;
	}

	.simple-bar-fill {
		height: 100%;
		transition: width 200ms ease;
	}

	.simple-bar-label {
		white-space: nowrap;
		font-family: var(--b2-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b2-font-size, 18px);
		line-height: 120%;
		letter-spacing: var(--b2-letter-spacing, -0.02em);
		font-weight: var(--b2-font-weight, 700);
		color: var(--color-black, #101010);
	}
`;
const clampRatio = (value) => {
    if (!Number.isFinite(value))
        return 0;
    if (value < 0)
        return 0;
    if (value > 1)
        return 1;
    return value;
};
exports.SimpleBarGraph = react_1.default.memo(({ value, max, trackColor = '#E9EBEF', fillColor = '#8BC3D0', height = 20, borderRadius = 0, showPercentLabel = false, className, }) => {
    const safeValue = Number.isFinite(value) ? Math.max(0, value) : 0;
    const safeMax = Number.isFinite(max) ? Math.max(0, max) : 0;
    const ratio = clampRatio(safeMax > 0 ? safeValue / safeMax : 0);
    const percentage = Math.round(ratio * 100);
    return (react_1.default.createElement(SimpleBarGraphStyled, { className: className, "$height": height, "$radius": borderRadius },
        react_1.default.createElement("div", { className: "simple-bar-track", style: { background: trackColor } },
            react_1.default.createElement("div", { className: "simple-bar-fill", style: { width: `${percentage}%`, background: fillColor } })),
        showPercentLabel && react_1.default.createElement("span", { className: "simple-bar-label" },
            percentage,
            "%")));
});
